import home_en from "../locales/en/home.json";

const langSetupOptions = {
  resources: {
    en: {
      home: home_en
    }
  },
  ns: ["home"],
  defaultNS: "home",
}

export default langSetupOptions